import {t} from "@lingui/core/macro";

import {LabelMedium} from "@khanacademy/wonder-blocks-typography";

/**
 * A component that displays the standard notice about Khanmigo chat retention.
 * Informs users that chats are kept for 60 days and then may be deleted.
 */
export function ChatRetentionNotice(): React.ReactElement {
    return (
        <LabelMedium>
            {t`Khanmigo chats are kept for 60 days, then may be deleted`}
        </LabelMedium>
    );
}
